import React from "react";
import styled from "styled-components";
import Colors from "../../common/Color";
import Images from "../../common/Images";

function WeMapModal({WeMapmodalOpen, setWeMapModalOpen}) {
  
  return (
    <>
        <ModalWrapper>
            <ModalTitle>WeMap</ModalTitle>
            {/* 프로젝트 사진 */}
            <Modals>
                <Image src={Images.WeMapArchitecture} />
                {/* 프로젝트 설명 */}
                <ModalInfo>
                    <InfoContainer>
                      <InfoTitle>프로젝트에서 맡은 부분</InfoTitle>
                      <Info style={{fontWeight : 500,marginTop: '20px'}}>1. Web/App 디자인</Info>
                      <Info>Figma로 WeMap의 <text style={{color : Colors.button}}>모든 페이지 디자인</text>을 함께 설계했습니다.</Info>
                      <Info style={{fontWeight : 500, marginTop: '20px'}}>2. 화면 구현 </Info>
                      <Info>설계된 디자인을 참고하여 <text style={{color : Colors.button}}>시작, 홈, 지역선택, 메뉴얼 창</text> 화면을 구현했습니다.</Info>
                      
                    </InfoContainer>
                </ModalInfo>
            </Modals>
        </ModalWrapper>
    </>
  );
};

function BBModal({BBmodalOpen, setBBmodalOpen}) {

    return (
        <>
            <ModalWrapper>
            <ModalTitle>Buzzer Beater</ModalTitle>
            {/* 프로젝트 사진 */}
            <Modals>
                <Image src={Images.BBArchitecture} />
                {/* 프로젝트 설명 */}
                <ModalInfo>
                  <InfoContainer>
                      <InfoTitle>프로젝트에서 맡은 부분</InfoTitle>
                      <Info style={{fontWeight : 500, marginTop: '20px'}}>1. UX/UI 디자인</Info>
                      <Info>Figma로 Buzzer Beater의 <text style={{color : Colors.button}}>모든 페이지 디자인</text>에 참여했습니다.</Info>
                      <Info style={{fontWeight : 500, marginTop: '20px'}}>2. UI 화면 구현 </Info>
                      <Info>설계된 디자인을 참고하여 <text style={{color : Colors.button}}>시작, 로그인, 농구팟 리스트, 랜덤 용병, 농구팟 참가목록</text> 화면을 구현했습니다.</Info>
                     
                    </InfoContainer>
                </ModalInfo>
            </Modals>
        </ModalWrapper>
        </>
    );
};

const ModalWrapper = styled.div`
  width : 100%;
  margin-bottom : 5%;
`;
const Modals = styled.div`
  display : flex;
  flex-direction : column;
  align-items : center;
`;
const ModalTitle = styled.div`
  margin-bottom : 5%;
  font-size : 2rem;
  font-weight : 700;
  font-family : 'BalooChettan';
`;
const Image = styled.img`
  width : 60%;
  margin : 3%;
  @media screen and (max-width : 1000px) {
    width : 80%;
    margin : 5%;
  }
  @media screen and (max-width : 500px) {
    width : 100%;
    margin : 10%;
  }
`;
const ModalInfo = styled.div`
  width : 100%;
  text-align : start;
`;
const InfoContainer = styled.div`
  width : 100%;
`;
const InfoTitle = styled.div`
  margin-bottom : 3%;
  font-size : 1.2rem;
  font-weight : 700;
  font-family : 'NotoSans';
  @media screen and (max-width : 768px) {
    font-size : 1rem;
  }
`;
const Info = styled.div`
  margin-bottom : 2%;
  font-size : 1.1rem;
  font-weight : 200;
  font-family : 'NotoSans';
  @media screen and (max-width : 1000px) {
    font-size : 0.95rem;
  }
`;

export {WeMapModal, BBModal};